import { React, PropTypes } from 'imports';
import { FormattedResource } from '../index';
import { dataUrl2Base64 } from 'utils/encoding/Base64';
import DropzoneComponent from 'react-dropzone-component';
import './FileInput.less';

class FileInput extends React.PureComponent {

    static get propTypes() {
        return {
            className: PropTypes.string,
            // uploadMultiple: PropTypes.bool, //todo: make multiple mode work
            onChange: PropTypes.func,
            previouslyUploadedFileName: PropTypes.string,
            acceptedFiles: PropTypes.string,
            acceptedFileTypes: PropTypes.string,
            maxFiles: PropTypes.number
        }
    }

    static get defaultProps() {
        return {
            className: '',
            maxFiles: 1,
            acceptedFileTypes: null
        }
    }

    state = {
        acceptedFiles: [],
        rejectedFiles: [],
    }

    _dropzoneRef = null;

    _dropzoneInstance = null;

    _onDropzoneInit = (dropzone) => {
        this._dropzoneInstance = dropzone;
    }

    _onFileAdded = (file) => {
        let newAcceptedFiles;

        this.setState((prevState) => {
            newAcceptedFiles = prevState.acceptedFiles.concat([file]);
            return {
                acceptedFiles: newAcceptedFiles,
            };
        });

        if (this.props.onChange) {
            this.props.onChange(this, newAcceptedFiles, this.state.rejectedFiles);
        }
    }

    _onMaxFilesExceeded = (file) => {
        if (this.props.maxFiles === 1) {
            this._dropzoneInstance.removeAllFiles();
            this._dropzoneInstance.addFile(file);
        }
    }

    _getAcceptedFiles = () => {
        if (!this._dropzoneInstance) {
            return [];
        }

        return this._dropzoneInstance.files;
    }

    // TODO pass all needed stuff via onChange, remove access to private methods
    _getAcceptedFileURL = (fileIndex) => {
        return new Promise((resolve, reject) => {
            let file = this._getAcceptedFiles()[fileIndex];

            let reader = new FileReader();

            reader.onload = () => {
                resolve(reader.result);
            };

            reader.onerror = () => {
                reject(reader.error);
            };

            if (file) {
                reader.readAsDataURL(file);
            } else {
                reject(new Error(`File with index ${fileIndex} does not exist in the file input.`));
            }
        });
    }

    render() {
        return <div className={'file-input ' + this.props.className} >
            <DropzoneComponent ref={(node) => { this._dropzoneRef = node }}
                config={{

                }}
                djsConfig={{
                    url: 'http://example.com',
                    clickable: true,
                    uploadMultiple: false,
                    autoProcessQueue: false,
                    maxFiles: this.props.maxFiles,
                    acceptedFiles: this.props.acceptedFileTypes
                }}
                eventHandlers={{
                    init: this._onDropzoneInit,
                    addedfile: this._onFileAdded,
                    maxfilesexceeded: this._onMaxFilesExceeded
                }}
            />
        </div>
    }
}

export default FileInput;